// constants
import { ChatSubmissionsActionTypes } from './constants';

export interface ChatSubmissionsActionType {
    type:
    | ChatSubmissionsActionTypes.API_RESPONSE_SUCCESS
    | ChatSubmissionsActionTypes.API_RESPONSE_ERROR
    | ChatSubmissionsActionTypes.CHAT_SUBMISSIONS_LIST
    payload: {} | string;
}

interface FiltersData {
    sortBy: string,
    limit: number,
    page: number,
    search: string
};

interface ResponseData {
    actionType: string,
    responseData: any,
}


// common success
export const chatSubmissionsApiResponseSuccess = ({ actionType, responseData }: ResponseData): ChatSubmissionsActionType => ({
    type: ChatSubmissionsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, responseData },
});
// common error
export const chatSubmissionsApiResponseError = (actionType: string, error: string): ChatSubmissionsActionType => ({
    type: ChatSubmissionsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const chatSubmissionsList = ({
    sortBy,
    limit,
    page,
    search,
}: FiltersData): ChatSubmissionsActionType => ({
    type: ChatSubmissionsActionTypes.CHAT_SUBMISSIONS_LIST,
    payload: {
        search,
        sortBy,
        limit,
        page,
    },
});




